const API_BASE_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8000';
const TOKEN_KEY = 'aivox_token';

export type AuthUser = {
  id: number;
  email: string;
  full_name: string | null;
  role: string;
};

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export function isAuthenticated(): boolean {
  return Boolean(getToken());
}

export async function login(username: string, password: string): Promise<string> {
  const body = new URLSearchParams();
  body.set('username', username.trim());
  body.set('password', password);

  const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: body.toString(),
  });

  if (!response.ok) {
    throw new Error('Неверный логин или пароль');
  }

  const data = await response.json();
  setToken(data.access_token);
  return data.access_token as string;
}

export async function fetchCurrentUser(): Promise<AuthUser | null> {
  const token = getToken();
  if (!token) return null;

  try {
    const response = await fetch(`${API_BASE_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!response.ok) {
      clearToken();
      return null;
    }

    return response.json();
  } catch {
    // Backend unavailable (e.g. still starting) — don't clear token for retry.
    return null;
  }
}

export function logout(): void {
  clearToken();
}
